/** Internal app paths only — blocks open redirects and javascript: URLs. */
export function isValidInternalPath(path) {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) return false;
  if (/[\s\\]/.test(path) || path.includes('://')) return false;
  if (/^(javascript|data|vbscript):/i.test(path)) return false;
  return /^\/[\w\-./?=&%#]*$/.test(path);
}

export function buildSameOriginAppUrl(path) {
  if (!isValidInternalPath(path)) return null;
  try {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    const isHashRouter = window.location.hash?.startsWith('#/');
    if (isHashRouter) {
      return `${window.location.origin}${window.location.pathname}#${path}`;
    }
    return url.href;
  } catch {
    return null;
  }
}

export function assignInternalPath(path) {
  if (!isValidInternalPath(path)) return false;
  if (window.location.hash?.startsWith('#/')) {
    window.location.hash = path;
    return true;
  }
  const href = buildSameOriginAppUrl(path);
  if (!href) return false;
  window.location.assign(href);
  return true;
}

export function replaceInternalPath(path) {
  const href = buildSameOriginAppUrl(path);
  if (!href) return false;
  window.location.replace(href);
  return true;
}

const ALLOWED_IMAGE_FETCH_HOSTS = new Set([
  'firebasestorage.googleapis.com',
  'storage.googleapis.com',
]);

const BLOCKED_IMAGE_HOSTS = /^(localhost|127\.\d+\.\d+\.\d+|0\.0\.0\.0|metadata\.google\.internal)$/i;

/** HTTPS fetch allowlist for report/PDF logo URLs — blocks SSRF to internal targets. */
export function isAllowedRemoteImageUrl(raw) {
  if (!raw || typeof raw !== 'string') return false;
  try {
    const url = new URL(raw, window.location.origin);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return false;
    if (url.username || url.password) return false;
    if (BLOCKED_IMAGE_HOSTS.test(url.hostname)) return false;
    if (url.origin === window.location.origin) return true;
    if (url.protocol !== 'https:') return false;
    return ALLOWED_IMAGE_FETCH_HOSTS.has(url.hostname);
  } catch {
    return false;
  }
}
